export default "__VITE_ASSET__DcdfunnL__"